/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { productCompareFlyOutStyles } from "@insite/content-library/Components/ProductCompareFlyOut";
import { getProp, safeColor } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { screen } from "@monsma/XDL/Helpers";
import Times from "@monsma/XDL/Icons/Times";
import { getContainerPadding } from "@monsma/XDL/Utilities";
import { imageHoverEffect, removeLinkStyle } from "@monsma/XDL/Utilities/sharedStyles";
import { css } from "styled-components";

(productCompareFlyOutStyles as any).compareProductsCarouselWrapper = {
    css: css`
        background: ${getColor("common.background")};
        box-shadow: ${getProp("theme.shadows.4")};
        position: fixed;
        right: 0;
        bottom: 0;
        left: 0;
        padding: 20px 0;
        z-index: ${getProp("theme.zIndex.level1")};
    `,
};

(productCompareFlyOutStyles as any).compareProductsCarouselGridContainer = {
    gap: 0,
    css: css`
        margin: 0 auto;
        ${getContainerPadding()};
    `,
};

(productCompareFlyOutStyles as any).compareProductsCarouselLeftGridItem = {
    width: [12, 12, 12, 9, 9],
    css: css`
        &&& {
            ${screen("lte", "md")} {
                margin-bottom: 30px;
            }

            ${screen("gte", "835")} {
                .swiper-navigation {
                    display: none;
                }
            }

            ${screen("1025", "1101")} {
                .swiper-slide {
                    width: 100px !important;
                    margin-right: 29px !important;
                }
            }
        }
    `,
};

(productCompareFlyOutStyles as any).compareProductsCarouselRightGridItem = {
    width: [12, 12, 12, 3, 3],
    align: "middle",
    css: css`
        flex-direction: column;
        justify-content: center;
    `,
};

(productCompareFlyOutStyles as any).headerCompareButton = {
    sizeVariant: "small",
    css: css`
        &&& {
            margin: 0 0 15px;
        }
    `,
};

(productCompareFlyOutStyles as any).headerRemoveAllLink = removeLinkStyle;

(productCompareFlyOutStyles as any).removeProductFromCompareButton = {
    sizeVariant: "small",
    css: css`
        &&& {
            padding: 0;
            background: ${getColor("common.ui10")};
            opacity: 80%;
            border-radius: 2px;
            border-color: ${getColor("common.ui10")};
            width: 20px;
            height: 20px;

            &:hover,
            &:focus {
                opacity: 100%;
            }
        }
    `,
};

(productCompareFlyOutStyles as any).removeProductFromCompareButtonIcon = {
    src: Times,
    size: 14,
    color: "common.background",
    css: css`
        &&& {
            top: unset;
        }
    `,
};

(productCompareFlyOutStyles as any).productCarouselProductCondensedStyles = {
    container: {
        gap: 0,
        css: css`
            position: relative;
        `,
    },
    imageGridItem: {
        css: css`
            flex-basis: 100%;
            max-width: 100%;
        `,
    },
    productDetailsGridItem: {
        width: 0,
    },
    productImageStyles: {
        linkWrappingImage: {
            css: css`
                &&& {
                    width: 100%;
                    height: 100px;
                    border: 1px solid ${getColor("common.border")};
                    border-radius: 4px;
                    overflow: hidden;
                    justify-content: center;

                    &:hover,
                    &:focus {
                        > div {
                            &:after {
                                opacity: 1;
                            }
                        }
                    }

                    img {
                        height: 100%;
                        object-fit: contain;
                        object-position: center;
                    }
                }
            `,
        },
        image: {
            css: css`
                ${imageHoverEffect};
            `,
        },
    },
    condensedActionsTemplateGridItem: {
        css: css`
            flex-basis: unset;
            max-width: unset;
            position: absolute;
            right: 5px;
            top: 4px;
        `,
    },
};
